<script>
  import MeteorList from "@/components/MeteorList.svelte";
  export let route, send, receive, url;
</script>

<MeteorList
  collectionName="customers"
  unitName="kunde"
  unitNamePlural="kunder"
  {...$$props}
  let:collection>
  <ul class="rows">
    <li class="hidden sm:flex font-bold py-1 px-2">
      <div class="w-3/12">ID</div>
      <div class="w-9/12">Navn</div>
    </li>
    {#each Object.entries(collection) as [key, item]}
      <li>
        <a
          href={url('./:id', { id: item._id })}
          class="flex flex-wrap py-1 px-2">
          <div class="sm:w-3/12 w-full">{item._id}</div>
          <div class="sm:w-9/12 w-full">{item.name || '[ny kunde]'}</div>
        </a>
      </li>
    {/each}
  </ul>
  <div slot="slot">
    <slot>
      <!-- optional fallback -->
    </slot>
  </div>
</MeteorList>
